import React from 'react';
import { useNavigate } from 'react-router-dom';
import {useLang} from "../../context/LanguageContext";
import Footer from "../../components/Footer";

const StrategiesPage = () => {
  const navigate = useNavigate();
  const { t } = useLang()

  return (
    <div className="bg-gray-100 min-h-screen relative">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded z-10"
      >
        {t('btn.back')}
      </button>

      <div className="px-5 pt-16 pb-10 max-w-[600px] mx-auto">
        {/* Main Strategy Title */}
        <div className="bg-green-500 text-white rounded p-3 mb-4 text-center font-bold text-lg">
          {t('txt.strategiesHeader1')}
        </div>

        {/* Strategy Explanation with image */}
        <div className="flex flex-col items-center bg-white shadow rounded p-4 mb-4">
          <h2 className="text-gray-800 text-base font-semibold mb-2">
            {t('txt.strategiesSubtitle1')}
          </h2>
          <img 
            src="/assets/images/bilet.png" 
            alt="Ticket" 
            className="w-32 h-auto mb-2"
          />
          <p className="text-sm text-gray-700">
            {t('txt.strategiesContent11')} <br />
            {t('txt.strategiesContent12')} <br />
            {t('txt.strategiesContent13')} <br />
          </p>
        </div>

        {/* Why does it work title */}
        <div className="bg-green-500 text-white rounded p-3 mb-4 text-center font-bold text-lg">
          {t('txt.strategiesHeader2')}
        </div>

        {/* Explanation card */}
        <div className="bg-white shadow rounded p-4 mb-4">
          <p className="text-sm text-gray-700 mb-2">
            {t('txt.strategiesContent21')}
          </p>
          <p className="text-sm text-gray-700">
            {t('txt.strategiesContent22')}
          </p>
        </div>

        {/* 18+ Logo and disclaimers */}
        <div className="flex flex-col items-center mb-4">
          <img 
            src="/assets/images/responsible.png" 
            alt="18+" 
            className="w-12 h-auto mb-2"
          />
          <div className="bg-white shadow rounded p-4 w-full text-center">
            <p className="text-red-600 text-sm font-bold mb-1">
              {t('txt.strategiesFooter1')}
            </p>
            <p className="text-green-600 text-sm font-bold">
              {t('txt.strategiesFooter2')}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StrategiesPage;
